export interface MilestoneLike {
  id: string;
  name: string;
  deadline: string | null;
  [key: string]: unknown;
}

export type InterleavedRow<A, M> = { kind: 'ap'; ap: A } | { kind: 'ms'; ms: M };

/**
 * Ordnet Meilensteine zwischen die AP-Zeilen (PHQ-101): ein Meilenstein steht vor dem ersten
 * AP, dessen Start nach seinem Datum liegt; übrige (auch ohne Datum) am Ende.
 */
export function interleaveMilestones<A extends { start_date: string | null }, M extends { deadline: string | null }>(
  aps: A[], milestones: M[],
): Array<InterleavedRow<A, M>> {
  const sorted = [...milestones].sort((a, b) => (a.deadline ?? '9999').localeCompare(b.deadline ?? '9999'));
  const out: Array<InterleavedRow<A, M>> = [];
  const open = sorted.filter((m) => m.deadline);
  const rest = sorted.filter((m) => !m.deadline);
  for (const ap of aps) {
    if (ap.start_date) {
      for (let i = 0; i < open.length;) {
        if ((open[i].deadline as string).slice(0, 10) < ap.start_date.slice(0, 10)) out.push({ kind: 'ms', ms: open.splice(i, 1)[0] });
        else i += 1;
      }
    }
    out.push({ kind: 'ap', ap });
  }
  open.forEach((ms) => out.push({ kind: 'ms', ms }));
  rest.forEach((ms) => out.push({ kind: 'ms', ms }));
  return out;
}
